import { render, staticRenderFns } from "./Select2Control.vue?vue&type=template&id=2b31e90f&"
import script from "./Select2Control.vue?vue&type=script&lang=js&"
export * from "./Select2Control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports